import InputTag from "./InputTag.vue";
export default InputTag;
